import { XStack, YStack, Text } from "tamagui";
import { MdInfoOutline } from "react-icons/md";

const Header = ({ title }: { title: string }) => {
  return (
    <YStack bg="white" borderBottomWidth={1}>
      <YStack maxWidth={400} px="$6" pt="$4" py="$3">
        <XStack gap="$4" ai="center">
          <YStack f={1}>
            <Text fontSize="$5" color="$gray10">
              LPG Cloud 瓦斯配送
            </Text>
            <Text fontSize="$9" fontWeight="700" color="$gray12">
              {title}
            </Text>
          </YStack>
          <MdInfoOutline size={24} color="#000" />
        </XStack>
      </YStack>
    </YStack>
  );
};

export default Header;
